// Facebook OAuth Configuration
export const FACEBOOK_OAUTH_CONFIG = {
  clientId: process.env.REACT_APP_FACEBOOK_CLIENT_ID || '960563116183235',
  redirectUri: `${window.location.origin}${process.env.PUBLIC_URL}/facebook-oauth-callback.html`,
  scope: 'public_profile email', // Request both public profile and email
  version: 'v17.0', // Use a more stable Facebook API version
};

export const FACEBOOK_OAUTH_ENDPOINTS = {
  auth: 'https://www.facebook.com/v17.0/dialog/oauth',
  token: 'https://graph.facebook.com/v17.0/oauth/access_token',
  userInfo: 'https://graph.facebook.com/me',
  userInfoWithFields: 'https://graph.facebook.com/me?fields=id,name,first_name,last_name,picture,email',
};

// Validate Facebook OAuth configuration
export const validateFacebookOAuthConfig = (): boolean => {
  return !!(FACEBOOK_OAUTH_CONFIG.clientId && FACEBOOK_OAUTH_CONFIG.redirectUri);
};

// Generate Facebook OAuth URL for popup flow (using authorization code flow)
export const generateFacebookOAuthPopupUrl = (): { url: string; state: string } => {
  if (!validateFacebookOAuthConfig()) {
    throw new Error('Facebook OAuth is not configured. Please set REACT_APP_FACEBOOK_CLIENT_ID in your .env file.');
  }

  const state = generateRandomState();

  const params = new URLSearchParams({
    client_id: FACEBOOK_OAUTH_CONFIG.clientId,
    redirect_uri: FACEBOOK_OAUTH_CONFIG.redirectUri,
    scope: FACEBOOK_OAUTH_CONFIG.scope,
    response_type: 'code', // Facebook only supports authorization code flow
    state,
  });

  const authUrl = `${FACEBOOK_OAUTH_ENDPOINTS.auth}?${params.toString()}`;
  return { url: authUrl, state };
};

// Generate random state for OAuth security
const generateRandomState = (): string => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

// Get Facebook OAuth configuration info
export const getFacebookOAuthConfigInfo = () => {
  return {
    isConfigured: validateFacebookOAuthConfig(),
    clientId: FACEBOOK_OAUTH_CONFIG.clientId,
    scope: FACEBOOK_OAUTH_CONFIG.scope,
    redirectUri: FACEBOOK_OAUTH_CONFIG.redirectUri,
    version: FACEBOOK_OAUTH_CONFIG.version,
    endpoints: FACEBOOK_OAUTH_ENDPOINTS,
  };
}; 